import { useCallback, useState } from 'react';
import { useUpdateEffect } from './use-update-effect';
import { useActualRef } from './use-actual-ref';
const keys = {
  ArrowUp: -1,
  ArrowDown: 1
};
export function useKeyboardNavigation(items, params = {}) {
  var _itemsRef$current$ind, _itemsRef$current;
  const {
    canUnselectAllItems = false,
    defaultSelected = -1
  } = params;
  const itemsRef = useActualRef(items);
  const [index, setIndex] = useState(defaultSelected);
  const onMouseEnter = useCallback(nextIndex => setIndex(nextIndex), []);
  const onMouseLeave = useCallback(() => setIndex(-1), []);
  const reset = useCallback(() => setIndex(-1), []);
  useUpdateEffect(() => {
    var _items$length;
    const maxIndex = ((_items$length = items == null ? void 0 : items.length) != null ? _items$length : 0) - 1;
    setIndex(currentIndex => maxIndex < currentIndex ? maxIndex : currentIndex);
  }, [items]);
  const onKeyDown = useCallback(e => {
    e.persist();
    setIndex(currentIndex => {
      if (!itemsRef.current) return currentIndex;
      const maxIndex = itemsRef.current.length - 1;
      const step = keys[e.key];
      if (!step) return currentIndex;
      e.preventDefault();
      e.stopPropagation();
      return getNextIndex(canUnselectAllItems ? -1 : 0, currentIndex, step, maxIndex);
    });
  }, [itemsRef, canUnselectAllItems]);
  const selectItem = useCallback(nextIndex => {
    if (!itemsRef.current) return;
    if (nextIndex < 0 || nextIndex >= itemsRef.current.length) return;
    setIndex(nextIndex);
  }, [itemsRef]);
  const selectedItem = (_itemsRef$current$ind = (_itemsRef$current = itemsRef.current) == null ? void 0 : _itemsRef$current[index]) != null ? _itemsRef$current$ind : null;
  return {
    index,
    reset,
    selectedItem,
    selectItem,
    onMouseEnter,
    onMouseLeave,
    onKeyDown
  };
}
function getNextIndex(min, current, step, max) {
  const maybeNextIndex = current + step;
  if (maybeNextIndex < min) {
    return max;
  }
  if (maybeNextIndex > max) {
    return min;
  }
  return maybeNextIndex;
}